import ModalEditing from './ModalEdition';

export default ModalEditing;
